__turbopack_context__.v({
  "ratio16x9": "CmsVideoEmbed-module__8VrH6q__ratio16x9",
  "ratio4x3": "CmsVideoEmbed-module__8VrH6q__ratio4x3",
});
